import { createSlice } from '@reduxjs/toolkit'
import { authService } from 'app/services/auth.service'
import { IUser } from 'types/user.types'
import { tokenReceived } from 'app/slices/actions'
import { logAccessTokenExpire } from 'utils/helpers/tokenHelper'

interface Auth {
  token: string | null
  id: null | string
  permissions: any;
  user: IUser | null
  accessToken: string | null
  refreshToken: string | null,
  expire: number | null
}

const initialAuthState: Auth = {
  token: null,
  id: null,
  permissions: {
    messaging: 0,
    newsFeed: 0,
    teamAndChannel: 0,
    settings: 0,
    videoConference: 0,
    userManagement: 0
  },
  user: null,
  accessToken: null,
  refreshToken: null,
  expire: null
}

export const { actions: authActions, reducer: authReducer } = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    login: (state, { payload }) => {
      state.id = payload.user._id
      state.token = payload.token
      state.permissions = payload.user.permissions;
      state.accessToken = payload.accessToken
      state.refreshToken = payload.refreshToken
    },
    updatePermissions: (state, {payload}) => {
      state.permissions = payload.permissions;
    },
    updateUserInfo: (state, {payload}) => {
      state.user = { ...state.user, ...payload }
    },
    updateUsersKvkkConsent: (state, { payload }) => {
      if (state.user) {
        state.user.isKvkkAccepted = payload.isKvkkAccepted
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tokenReceived, (state, {payload}) => {
      const expire = logAccessTokenExpire(payload.accessToken);
      if(expire){
        state.expire = expire
      }
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
    })
    builder.addMatcher(authService.endpoints.login.matchFulfilled, (state, { payload }) => {
      if(payload?.accessToken){
        const expire = logAccessTokenExpire(payload.accessToken);
        if(expire){
          state.expire = expire
        }
        state.token = payload.token
        state.id = payload.user._id
        state.permissions = payload.user.permissions;
        state.user = {
          ...payload.user,
          avatar: payload.user.avatar ?? "",
          email: payload.user.email ?? "",
          fullname: payload.user.fullname ?? "",
        };
        state.accessToken = payload.accessToken
        state.refreshToken = payload.refreshToken
        // axios header ve clientChannel.postMessage listenerMiddleware tarafından otomatik yapılıyor
      }
    })
    builder.addMatcher(authService.endpoints.checkMfa.matchFulfilled, (state, { payload }) => {
      const expire = logAccessTokenExpire(payload.accessToken);
      if(expire){
        state.expire = expire
      }
      state.token = payload.token
      state.id = payload.user._id
      state.permissions = payload.user.permissions;
      state.user = {
        ...payload.user,
        status: "ONLINE",
        avatar: payload.user.avatar ?? "",
        email: payload.user.email ?? "",
        fullname: payload.user.fullname ?? "",
      };
      state.accessToken = payload.accessToken
      state.refreshToken = payload.refreshToken
      // axios header ve clientChannel.postMessage listenerMiddleware tarafından otomatik yapılıyor
    })
  },
})
